// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";

import moment from "moment";
import { getContacts, getCustomerListFile } from "network/service";
import { useNavigate } from "react-router-dom";

import * as XLSX from 'xlsx';
import TableData from "./data";


function Customers() {

    const initialFilters = JSON.parse(localStorage.getItem('filters')) || {
        from: new Date(),
        to: new Date(),
        status: [],
    };
    const [loading, setLoading] = useState(false);
    const [dElems, setDelems] = useState([]);
    const [data, setData] = useState([]);
    const { formCustomerRows, customerHeaders } = TableData();

    const exportToExcel = (filename, details) => {
        const ws = XLSX.utils.json_to_sheet(details);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        XLSX.writeFile(wb, `${filename}.xlsx`);
    };


    useEffect(() => {
        getContacts().then((resp) => {
            setData(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }, [setData]);


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}><Grid container spacing={6}>
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={3}
                            px={2}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                        >
                            <MDTypography variant="h6" color="white">
                                Clients Table
                            </MDTypography>
                        </MDBox>
                        <MDBox
                            mx={2}
                            mt={0}
                            py={2}
                            px={0}
                            borderRadius="lg"
                            alignSelf="flex-end"
                        >
                            <MDButton variant="gradient" color="info" style={{ margin: 5 }}
                                onClick={async () => {
                                    const response = await getCustomerListFile();
                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                    const a = document.createElement('a');
                                    a.href = url;
                                    a.download = `${moment().valueOf()}_customer_list.xlsx`;
                                    document.body.appendChild(a);
                                    a.click();
                                    window.URL.revokeObjectURL(url);
                                    document.body.removeChild(a);
                                }}>
                                <Icon sx={{ fontWeight: "bold" }}>download</Icon>
                                &nbsp;Export
                            </MDButton>
                        </MDBox>
                        <MDBox pt={0}>
                            <DataTable
                                table={{ columns: customerHeaders, rows: formCustomerRows(data) }}
                                canSearch
                            />
                        </MDBox>
                    </Card>
                </Grid>
            </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default Customers;
